export default __webpack_public_path__ + "static/22-e076acff5e57b9a1126700e4705109fd.png";